import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const contactItems = [
  {
    title: "Email",
    value: "4lab@4-lab.com",
    icon: "ri-mail-line",
    href: "mailto:4lab@4-lab.com",
  },
  {
    title: "Phone",
    value: "+82 2 881 5738",
    icon: "ri-phone-line",
    href: "tel:+8228815738",
  },
  {
    title: "Fax",
    value: "+82 2 881 5739",
    icon: "ri-printer-line",
  },
  {
    title: "Address",
    value:
      "6F, Room 19, 540 Misadaero, Hanam-si, Gyeonggi-do\n(Hyundai Knowledge Industry Center Hangang Misa 2nd)",
    icon: "ri-map-pin-line",
  },
  {
    title: "Response Time",
    value: "We respond to inquiries within 1–2 business days.",
    icon: "ri-time-line",
  },
];

export default function CTASection() {
  const { ref, isVisible } = useScrollAnimation();

  const handleScrollToContact = () => {
    const el = document.querySelector("#contact-details");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleMapClick = () => {
    // TODO: Replace with actual map URL later
    // window.open("https://maps.example.com", "_blank");
  };

  return (
    <section id="contact" className="py-24 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Top CTA banner */}
        <div
          className={`rounded-3xl bg-gradient-to-r from-blue-400 to-blue-500 p-12 md:p-16 text-center mb-20 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
            Transform Your Workplace Today
          </h2>
          <p className="text-white/80 text-base mb-8 max-w-2xl mx-auto leading-relaxed">
            Streamline approvals, asset operations, and workplace workflows in one
            unified platform.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={handleScrollToContact}
              className="px-8 py-3.5 bg-white text-blue-400 font-semibold rounded-full hover:bg-blue-50 transition-all duration-200 hover:scale-105 cursor-pointer whitespace-nowrap text-sm"
            >
              Contact Us
            </button>
            <a
              href="mailto:4lab@4-lab.com"
              className="px-8 py-3.5 border-2 border-white/50 text-white font-semibold rounded-full hover:border-white hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              Send Email
            </a>
          </div>

          <p className="text-white/50 text-xs mt-6">
            Get in touch for product inquiries, demos, or partnership discussions
          </p>
        </div>

        {/* Contact + Map */}
        <div
          id="contact-details"
          className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 transition-all duration-700 delay-200 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {/* Left */}
          <div>
            <div className="mb-10">
              <span className="text-xs font-bold uppercase tracking-widest text-blue-400 mb-3 block">
                Contact Information
              </span>
              <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
                Let&apos;s Start the Conversation
              </h3>
              <p className="text-slate-500 text-base leading-relaxed max-w-xl">
                Reach out to our team for product inquiries, partnership discussions,
                or service-related questions.
              </p>
            </div>

            <div className="space-y-5">
              {contactItems.map((item, index) => {
                const content = item.href ? (
                  <a
                    href={item.href}
                    className="text-slate-600 leading-relaxed hover:text-blue-600 transition-colors"
                  >
                    {item.value}
                  </a>
                ) : (
                  // <p className="text-slate-600 leading-relaxed">{item.value}</p>
                    <p className="text-slate-600 leading-relaxed">
                      {/* \n이 포함되어 있다면 잘라서 처리, 아니면 그냥 출력 */}
                      {item.value.split('\n').map((line, i) => (
                        <span key={i}>
                          {line}
                          {i < item.value.split('\n').length - 1 && <br />}
                        </span>
                      ))}
                    </p>
                );

                return (
                  <div
                    key={item.title}
                    className={`rounded-2xl border border-slate-200 bg-white p-5 hover:border-blue-200 hover:shadow-sm transition-all duration-300 ${
                      isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                    }`}
                    style={{ transitionDelay: `${index * 80 + 250}ms` }}
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center shrink-0">
                        <i className={`${item.icon} text-blue-600 text-xl`} />
                      </div>
                      <div className="min-w-0">
                        <div className="text-slate-900 font-semibold text-lg mb-1.5">
                          {item.title}
                        </div>
                        {content}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-8 rounded-3xl border border-blue-100 bg-blue-50 p-6 md:p-7">
              <h4 className="text-xl font-bold text-slate-900 mb-2">Quick Contact</h4>
              <p className="text-slate-600 text-sm leading-relaxed mb-5">
                Prefer direct communication? Call or email us and our team will
                assist you as quickly as possible.
              </p>

              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="tel:+82 2 881 5738"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-400 text-white font-semibold rounded-full hover:bg-blue-500 transition-all duration-200 hover:scale-[1.02] whitespace-nowrap"
                >
                  <i className="ri-phone-line" />
                  Call Us
                </a>
                <a
                  href="mailto:4lab@4-lab.com"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-blue-400 font-semibold rounded-full border border-blue-200 hover:bg-blue-100/60 transition-all duration-200 whitespace-nowrap"
                >
                  <i className="ri-mail-line" />
                  Send Email
                </a>
              </div>
            </div>
          </div>

          {/* Right */}
          <div>
            <div className="mb-10">
              <span className="text-xs font-bold uppercase tracking-widest text-blue-400 mb-3 block">
                Visit Us
              </span>
              <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
                Find Our Location
              </h3>
              <p className="text-slate-500 text-base leading-relaxed max-w-xl">
                Visit our office for meetings and consultations. Detailed directions
                and map links can be added later.
              </p>
            </div>

            <div className="rounded-3xl border border-slate-200 bg-white overflow-hidden shadow-sm">
              <div className="relative h-[320px] md:h-[360px] bg-slate-100 overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.8911389241525!2d127.20555232720976!3d37.55762850000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cb164b0039633%3A0xe4e1e4a243edb8a5!2s6F%2C%20Building%20B%2C%20540%20Misa-daero%2C%20Hanam-si%2C%20Gyeonggi-do!5e0!3m2!1sen!2skr!4v1776843951287!5m2!1sen!2skr"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="FOURLAB Location"
                  className="w-full h-full"
                />
              </div>

              <div className="p-6 md:p-7">
                <div className="flex items-start gap-3 mb-5">
                  <div className="w-10 h-10 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center shrink-0">
                    <i className="ri-information-line text-blue-600 text-lg" />
                  </div>
                  <div>
                    <p className="text-slate-900 font-semibold mb-1">
                      Click the map to open directions.
                    </p>
                    <p className="text-slate-500 text-sm leading-relaxed">
                      Contact us before your visit and we can assist with parking and
                      visitor access guidance.
                    </p>
                  </div>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                  <div className="text-slate-900 font-semibold mb-2">Office Address</div>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    6F, Room 19, 540 Misadaero, Hanam-si, Gyeonggi-do
                    <br />
                    (Hyundai Knowledge Industry Center Hangang Misa 2nd)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}